import React from "react";

const PendingIcon = ({
  style = {},
  width = "70",
  height = "70",
  className = "",
  fill = "#7758B3",
  stroke = "#7758B3",
  viewBox = "0 0 70 70",
}) => (
<svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#FF8311"
        d="M7.907.111c2.186 0 4.05.772 5.593 2.315C15.043 3.969 15.815 5.827 15.815 8s-.772 4.03-2.315 5.574c-1.543 1.543-3.407 2.315-5.593 2.315-2.185 0-4.049-.772-5.592-2.315C.772 12.031 0 10.173 0 8s.772-4.03 2.315-5.574C3.858.883 5.722.11 7.907.11zm.797 11.852V10.37H7.11v1.593h1.593zm0-3.185V4.037H7.11v4.74h1.593z"
      ></path>
    </svg>
   
);

export default PendingIcon;
